<template>
    <MenuBase :hidden="props.hidden"  :disabled="props.disabled" 
        tooltipText="Play song" 
        :tooltipPosition="props.tooltipPosition"
        @menuClick="play()">
        <PlayCircleIcon 
            class="size-6" 
            :class="{'!text-gray-500 dark:!text-gray-400': disabled,
                '!text-red-500 dark:!text-red-400 hover:text-red-700 dark:hover:text-red-400': !disabled}"/>
    </MenuBase>    
</template>
<script setup>
import { defineProps, defineEmits, watch, ref } from 'vue'
import MenuBase from '@/components/common/menus/MenuBase.vue';
import { PlayCircleIcon } from '@heroicons/vue/24/solid';
import { appEvents } from '@/store/app.events';

const emit = defineEmits(['play'])
const props = defineProps( {
    disabled: {
        type: Boolean,
        default: true
    },
    hidden: {
        type: Boolean,
        default: true
    },
    tooltipPosition: {
        type: String,
        default: 'top',
        validator: (value) => {
            return ['top', 'bottom', 'left', 'right'].includes(value);
        }
    }
});

const disabled = ref(props.disabled);

const play = () => {
    emit('play');
}

watch(() => props.disabled, (newVal) => {
    disabled.value = newVal;
});
appEvents.on('no-media', () => {
    console.log('no-media', disabled.value);
    disabled.value = true;
});
appEvents.on('has-media', () => {
    console.log('has-media', disabled.value);
    disabled.value = false;
});
</script>